import { NotificationProgrammatic as Notification } from "buefy";

const defaultOptions = {
  autoClose: true,
  position: "is-top",
  duration: 5000,
  progressBar: true,
  pauseOnHover: true
};

/**
 * Muestra una notificación en la interfaz de usuario
 * @param {"is-success" | "is-danger" | "is-info" | "is-warning"} type Tipo de notificación
 * @param {string} message Mensaje a mostrar
 * @param {Partial<typeof defaultOptions>} options Opciones personalizadas (opcionales)
 */
function notify(type, message, options = {}) {
  Notification.open({
    ...defaultOptions,
    ...options,
    message,
    type
  });
}

export const notifySuccess = (message, options) =>
  notify("is-success", message, options);

export const notifyError = (message, options) =>
  notify("is-danger", message, options);

export const notifyInfo = (message, options) =>
  notify("is-info", message, options);

export const notifyWarning = (message, options) =>
  notify("is-warning", message, options);

export default {
  install(Vue) {
    Vue.prototype.$notifySuccess = notifySuccess;
    Vue.prototype.$notifyError = notifyError;
    Vue.prototype.$notifyInfo = notifyInfo;
    Vue.prototype.$notifyWarning = notifyWarning;
  }
};
